import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Sidebar, Icon, Segment, Responsive } from 'semantic-ui-react';
import i18next from 'i18next';
import PropTypes from 'prop-types';

class SideEditor extends Component {
    state = {}

    handleOnUpdate = (e, { width }) => this.setState({ width })

    componentWillUnmount() {
        this.props.handleClose();
    }

    render() {
        const direction = i18next.dir();

        return (
            <Responsive
                fireOnMount
                onUpdate={this.handleOnUpdate}
            >
                <Sidebar
                    as={Segment}
                    animation='overlay'
                    width='wide'
                    direction='right'
                    visible={Boolean(this.props.visible)}
                    vertical
                    style={{
                        background: 'white',
                        padding: 0,
                        paddingBottom: 10,
                        direction: 'ltr',
                        width: this.state.width > Responsive.onlyMobile.maxWidth ? null : '100%'
                    }}
                >
                    <Segment secondary basic style={{ direction, marginBottom: 0, display: 'flex', justifyContent: 'space-between' }}>
                        {this.props.title}
                        <Icon name="close" onClick={this.props.handleClose} style={{ cursor: 'pointer' }} />
                    </Segment>
                    <div style={{ direction, padding: 10 }}>
                        {this.props.children}
                    </div>
                </Sidebar>
            </Responsive>
        );
    }
}

SideEditor.propTypes = {
    visible: PropTypes.any,
    handleClose: PropTypes.func,
    renderSide: PropTypes.func,
    children: PropTypes.object,
    title: PropTypes.string
};

export default connect(null)(SideEditor);